export async function getSmartValuesUseCase(customer_id, customerRepostitory) {
    const result = await customerRepostitory.get_smart_values(customer_id);

    return result;
}